import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { InlineNotification } from '../../../visual-components/form-inline-notification/form-inline-notification';
import { Select, SelectOption } from '../../../visual-components/select/select';

type FormSelectProps = {
  name: string;
  label: string;
  defaultValue?: string;
  options: SelectOption[];
  rules?: { required: string };
  helperMsg?: string;
  placeholder: string;
  required?: boolean;
  isDirty: boolean;
  disabled?: boolean;
  inlineNotification?: InlineNotification;
};

export const FormSelect: React.FC<FormSelectProps> = ({
  name,
  label,
  defaultValue,
  options,
  helperMsg,
  placeholder,
  rules,
  required = false,
  isDirty = false,
  disabled = false,
  inlineNotification,
}) => {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field }) => (
        <Select
          {...field}
          ariaLabel={label}
          defaultValue={defaultValue}
          disabled={disabled}
          helperMsg={helperMsg}
          inlineNotification={inlineNotification}
          isDirty={isDirty}
          label={label}
          mandatory={required}
          options={options}
          placeholder={placeholder}
        />
      )}
    />
  );
};
